import React from "react";

import { observer } from "mobx-react";
import Image from "next/legacy/image";
import Link from "next/link";
import pluralize from "pluralize";
import PropTypes from "prop-types";
import styled from "styled-components";

const StyledImgWrapper = styled.div`
  height: 240px;
`;

const StyledVenueLink = styled.a`
  color: inherit;
  text-decoration: none;
  cursor: pointer;
  height: 100%;

  h2 {
    font-size: 1.5rem;
    text-align: center;
    padding-top: 5px;
  }
`;

function Venue(props) {
  const { venue, placeholder } = props;

  const imgSrc = venue?.logoUrlFull || placeholder?.url || null;

  return (
    <Link href={`/venue/${venue.identifier}`} passHref legacyBehavior>
      <StyledVenueLink>
        <StyledImgWrapper className="mb-3 d-flex flex-column justify-content-center align-items-center position-relative">
          {imgSrc ? (
            <Image
              alt={venue.displayName}
              layout="fill"
              objectFit="contain"
              src={imgSrc}
            />
          ) : (
            <h3>{venue?.displayName}</h3>
          )}
        </StyledImgWrapper>
        <h2>{venue.displayName}</h2>
        <span>{pluralize("Vacancy", venue.totalVacancies, true)}</span>
      </StyledVenueLink>
    </Link>
  );
}

export default observer(Venue);

Venue.propTypes = {
  placeholder: PropTypes.shape({
    data: PropTypes.shape({
      attributes: PropTypes.shape({
        url: PropTypes.string,
      }),
    }),
  }),
  venue: PropTypes.shape({
    displayName: PropTypes.string,
    id: PropTypes.string,
    identifier: PropTypes.string,
    logoUrlFull: PropTypes.string,
    totalVacancies: PropTypes.number,
  }),
};

Venue.defaultProps = {
  placeholder: null,
  venue: null,
};
